import { styled } from "theme/default/styled";
import { setFlexDFFDC } from "theme/setter/setFlexValues/setFlexDFFDC";

export const STerminalsListContainer = styled.div`
  margin-left: 16px;
  padding: 16px 0;

  ${setFlexDFFDC};
`;
